/** Pure editor serialization. Preserve untouched values, including scalar types.
 * Changed numeric/boolean values must retain their original scalar type.
 * Other edited values keep the existing JSON-object/array or plain-text behavior.
 */

export function valueToEditorString(v: unknown): string {
  if (v === null || v === undefined) return "";
  if (typeof v === "string") return v;
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  try {
    return JSON.stringify(v, null, 2);
  } catch {
    return String(v);
  }
}

export function looksLikeJson(raw: string): boolean {
  const t = raw.trim();
  return t.startsWith("{") || t.startsWith("[");
}

export function parseEditorValue(
  raw: string,
  original?: unknown,
): { ok: true; value: unknown } | { ok: false; kind: "json" | "number" | "boolean" } {
  if (original !== undefined && raw === valueToEditorString(original)) {
    return { ok: true, value: original };
  }
  const scalar = typeof original;
  if (scalar === "number" || scalar === "boolean") {
    try {
      const value: unknown = JSON.parse(raw.trim());
      if (typeof value === scalar && (scalar !== "number" || Number.isFinite(value))) {
        return { ok: true, value };
      }
    } catch {
      /* Invalid scalar is reported by the existing inline error. */
    }
    return { ok: false, kind: scalar };
  }
  if (looksLikeJson(raw)) {
    try {
      return { ok: true, value: JSON.parse(raw) };
    } catch {
      return { ok: false, kind: "json" };
    }
  }
  return { ok: true, value: raw };
}
